import React, { useState } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "i18n"

// Material UI
import { makeStyles } from "@material-ui/core/styles"
import {
  Grid,
  Typography,
  Paper,
  Chip,
  useTheme,
  useMediaQuery
} from "@material-ui/core"

// Components
import Button from "components/shared/Button"
import AllSkillsDialog from "components/shared/AllSkillsDialog"

// Helpers
import { truncateString } from "shared/helpers"

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(3),
    border: `solid 0.5px ${theme.palette.primary.main}`,
    width: "inherit"
  },
  capitalize: {
    whiteSpace: "pre-line"
  }
}))

export default function SkillsObtainedCard({ items }) {
  const { t } = useTranslation()

  const theme = useTheme()
  const xsDown = useMediaQuery(theme.breakpoints.down("xs"))

  const classes = useStyles()

  const [open, setOpen] = useState(false)

  return (
    <>
      <Paper className={classes.paper}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="h6" className="text-bold">
              {t("Skills you will learn")}
            </Typography>
          </Grid>

          <Grid item container spacing={2} alignItems="center">
            {items.map((skill, index) => {
              if (index < 8)
                return (
                  <Grid item key={index}>
                    <Chip
                      label={
                        <Typography
                          variant="body2"
                          className={classes.capitalize}
                        >
                          {xsDown ? truncateString(skill, 30) : skill}
                        </Typography>
                      }
                    />
                  </Grid>
                )
              return null
            })}
            <Grid item onClick={() => setOpen(true)}>
              <Button>
                {items.length > 8 && `...${items.length - 8} more`}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <AllSkillsDialog
        skills={items}
        open={open}
        handleClose={() => setOpen(false)}
      />
    </>
  )
}

SkillsObtainedCard.propTypes = {
  items: PropTypes.array.isRequired
}

SkillsObtainedCard.defaultProps = {
  items: []
}
